//TODO: move to foxden-version-controller-client or new repo
import { GraphQLClient } from 'graphql-request';

import {
  getSdk,
  Sdk,
  UserPaymentPlanOptionByQuoteId
} from '../generated/payment-graphql';
import getEnv from '../utils/getEnv';

export class PaymentClient {
  sdk: Sdk;

  constructor(versionNumber?: string) {
    const graphQLClient = new GraphQLClient(
      PaymentClient.getPaymentURL(versionNumber)
    );
    this.sdk = getSdk(graphQLClient);
  }

  /**
   * Returns a SDK of rating-quoting backend.
   * @returns a sdk that has all APIs of rating-quoting backend.
   */
  public getSDK(): Sdk {
    return this.sdk;
  }

  /**
   * Retrieves the payment plan options for every product (line of business) in
   * an application group.
   *
   * @param {string} groupId ID of the application group to get the payment plan options.
   * @returns {Record<string, Array<UserPaymentPlanOptionByQuoteId>>} Returns a Promise for a
   *          map keyed by lobType (e.g. "GL", "EO"); each value is the array of payment plan
   *          options for that line of business.
   */
  public async getUserPaymentPlanOptionsByGroupId(
    groupId: string
  ): Promise<Record<string, Array<UserPaymentPlanOptionByQuoteId>>> {
    const result = await this.sdk.getUserPaymentPlanOptionsByGroupId({
      groupId
    });
    // The backend returns this as a JSONObject scalar (an arbitrary-key map),
    // so it is typed as `any` by codegen and narrowed here to the per-lob shape.
    return result.getUserPaymentPlanOptionsByGroupId as Record<
      string,
      Array<UserPaymentPlanOptionByQuoteId>
    >;
  }

  static versionUrl(baseUrl: string, versionNumber?: string): string {
    // regex to replace version number in url
    const regex = /\d{4}-\d{2}-\d{2}/g;
    return versionNumber ? baseUrl.replace(regex, versionNumber) : baseUrl;
  }

  public static getPaymentURL(versionNumber?: string): string {
    const { REACT_APP_PAYMENT_GRAPHQL_URL } = getEnv();

    return PaymentClient.versionUrl(
      REACT_APP_PAYMENT_GRAPHQL_URL,
      versionNumber
    );
  }

  public static getPaymentFrontendURL(versionNumber?: string): string {
    const { REACT_APP_PAYMENT_FRONTEND_URL } = getEnv();

    return PaymentClient.versionUrl(
      REACT_APP_PAYMENT_FRONTEND_URL,
      versionNumber
    );
  }
}
